import { render, staticRenderFns } from "./TicketBonuses.vue?vue&type=template&id=4783663f&"
import script from "./TicketBonuses.vue?vue&type=script&lang=js&"
export * from "./TicketBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports